export default __webpack_public_path__ + "static/custom-logo-3-b6010bc6c97b57327d2d70f62c9bb186.webp";